// One request batch at a time. Events received while it runs request one
// trailing refresh, so reconnects and mutations are not lost or multiplied.
export function createRefreshQueue(operation) {
  let active = true;
  let pending = false;
  let task = null;
  const refresh = () => {
    if (!active) return Promise.resolve();
    pending = true;
    if (!task) {
      task = Promise.resolve().then(async () => {
        try {
          while (active && pending) {
            pending = false;
            await operation(() => active);
          }
        } finally { task = null; }
      });
    }
    return task;
  };
  return { refresh, stop() { active = false; pending = false; } };
}
